import { NanoID, UUID } from '../../../../../types';

import { ProjectUUID } from '../../../../projects/projectsTypes';
import { TaskNanoID, TaskUUID } from '../../../../tasks/tasksTypes';

export interface SelectProjectAndTaskFormData {
  selectedProject: { value: string | UUID | NanoID; label: string } | null;
  selectedTaskId: string | null;
}

export type SelectProjectAndTaskFormOnSubmitAction = (value: {
  projectUuid: ProjectUUID;
  taskUuid: TaskUUID | TaskNanoID | null;
}) => Promise<unknown>;

export enum SelectProjectAndTaskFormFields {
  SELECTED_PROJECT = 'selectedProject',
  SELECTED_TASK_ID = 'selectedTaskId'
}
